import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EssentialService {

  constructor(private httpClient: HttpClient) { }

  public getPosts(request: any) {
    // return this.httpClient.get(`/BolgArchive/GetPosts/1/1/1000/${ids}`);
    return this.httpClient.post<any>("/BolgArchive/GetPosts", {...request,pageSize:request.pageSize||10});


  }
  public getYearAndMonth(startYear=null,CategoriesIds = null) {
    return this.httpClient.post(`/BolgArchive/GetPostByYearAndMonth`,{startYear,CategoriesIds});
  }
  public getData(apiLink: string) {
    return this.httpClient.get(apiLink);
  }
  public getCategoryMenus(id: number) {
    return this.httpClient.get(`/Menus/GetMenusByCategoryId/${id}/2`);
  }
  public getMenusByGroup(id: number, activeSlug? : string ) {
    if(activeSlug){

    return this.httpClient.get(`/Menus/GetMenusByGroupId/${id}/${activeSlug}`);
  }
  return this.httpClient.get(`/Menus/GetMenusByGroupId/${id}`);

  }
  public getMenuBreadCrumb(id: number) {
    return this.httpClient.get(`/Menus/GetMenuBreadCrumb/${id}`);
  }
  public getMediaData(path: string) {
    return this.httpClient.post('/Media/GetFolderContent', { folderPath: path ? path : null });
  }
  public postData(apiLink: string, requestBody: any) {
    return this.httpClient.post(apiLink, requestBody);
  }
  public search(query: any) {
    return this.httpClient.post('/Search/full-search', query);
  }
  public getParentMenus(id: number) {
    return this.httpClient.get(`/Menus/GetParentMenus/${id}`);
  }
  public GetSubMenus(MenuGroupId, MenuId, Relation) {
    return this.httpClient.get(`/Menus/GetMenusForWeb/${MenuGroupId}/${MenuId}/${Relation}`);
  }
  public sendNotification(data) { 
    return this.httpClient.post(`/Notification/Send`, data)
    
  }
}
